import { LitElement, html, svg } from 'lit';

export class IconPlayhouse32 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><title>Klatrestativ</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M3 30.667V6M13 30.667V6M1.248 7.341 8 1.333l6.752 6.008M18.667 14.667V24M25.333 14.667V24M3 21.333h10M16.667 24h10.667M3 14.667h26.167a1.5 1.5 0 0 1 1.5 1.5v14.5M3 8h10M3 28h10"></path></svg>`; }
}
if (!customElements.get('f-icon-playhouse32', IconPlayhouse32)) {
  customElements.define('f-icon-playhouse32', IconPlayhouse32);
}